import { render, staticRenderFns } from "./Shrimp.vue?vue&type=template&id=6da91c41&lang=pug&"
import script from "./Shrimp.vue?vue&type=script&lang=ts&"
export * from "./Shrimp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports